import React, { useContext,   useState, useEffect } from "react";
import { Switch, Route, __RouterContext } from "react-router-dom";
import { useTransition, animated, config } from "react-spring";

import './App.css'

import  MainPage  from "./components/MainPage";
import  Solution from "./components/Solution";
import  Product from "./components/Poduct";
import  Pricing from "./components/private_beta";
import  Contact from "./components/Contact";
import  admin_Dashboard from "./components/admin_main_dashboard";
import  user_Dashboard from "./components/dashboard/Dashboard";
import  SighIn from "./components/sighIn";
import  Navbah  from "./components/Navbar";
import  FooterIDMS from "./components/FooterIDMS";


const App = () => {

  const { location } = useContext(__RouterContext);

  const [index, set] = useState(0)
  //const transitions = useTransition(slides[index], item => item.id, {
  const transitions = useTransition(location, location => location.pathname, {
    from: { opacity: 0, transform: "translate(100%, 0)" },
    enter: { opacity: 1, transform: "translate(0%, 0)" },
    leave: { opacity: 0, transform: "translate(-50%, 0)" },
    config: config.molasses,
  });



  useEffect(() => void setInterval(() => set(state => (state + 1) % 4), 4000), []) ;

   /*<Route exact path="/login"      component={Login} />
              <Route exact path="/register"   component={Register} />
              <Route exact path="/dashboard"  component={Dashboard} />*/
  

  return (
    <>
      <Navbah />
      <main className="container-fluid">

        {transitions.map(({ item, props, key }) => (
          <animated.div key={key}  style={props}
          >
            <Switch location={item}>

              <Route exact path="/"                 component={MainPage} />
              <Route exact path="/home"             component={MainPage} />
              <Route exact path="/product"          component={Product} />
              <Route exact path="/solution"         component={Solution} />
              <Route exact path="/pricing"          component={Pricing} />
              <Route exact path="/contact"          component={Contact} />

              <Route exact path="/login"            component={SighIn} />
              <Route exact path="/admin_dashboard"  component={admin_Dashboard} />
              <Route exact path="/user_dashboard"   component={user_Dashboard} />
             


            </Switch>
            
          </animated.div>
        ))}

      </main>

      <FooterIDMS />
    </>
  );
};

export default App;
